export function restoreFlatform() {
  let flatform = null;

  try {
    const storedData = localStorage.getItem("flatform");

    if (storedData) {
      flatform = JSON.parse(storedData);
    }
  } catch (err) {
    // If stored data is not a strigified JSON this might fail,
    // that's why we catch the error
  }

  return flatform;
}

export function storeFlatform(flatform) {
  localStorage.setItem("flatform", JSON.stringify(flatform));
}
